export function ProgressBar({ current, total, isSinistre }) {
  const color = isSinistre ? 'bg-rose-500' : 'bg-violet-500';
  return (
    <div className="mt-2 flex items-center gap-2">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`h-1 flex-1 rounded-full ${i < current ? color : 'bg-slate-200'}`}
        />
      ))}
      <span className="text-[10.5px] text-slate-500 font-mono ml-1">
        étape {current}/{total}
      </span>
    </div>
  );
}
